export default __webpack_public_path__ + "static/tv-show-11-5407e6123379f27d901a60540df17883.jpg";